import React from 'react'
import moment from 'moment'

import ContentHeader from '../../containers/ContentHeader'
import styles from './Reports.css'
import {
  KARDIA_PRO_START_DATE,
  KARDIA_PRO_END_DATE,
  HEADER_HEIGHT,
  getEsignOptions,
  getExportOptions,
} from '../../constants'
import { ReportTable } from '../../containers/Tables'
import { needToBustCache } from '../../store/appReducer'
import { checkRpmFeatureEnabled } from 'configs'
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent'
import EcgLoader from 'legacy/containers/EcgLoader'

class Reports extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      innerHeight: 0,
      innerWidth: 0,
    }
    this.beginningDate = KARDIA_PRO_START_DATE
    this.today = KARDIA_PRO_END_DATE
  }
  UNSAFE_componentWillMount() {
    const {
      dataLastUpdated,
      getReportsData,
    } = this.props

    getReportsData(needToBustCache(dataLastUpdated))

    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }

  render() {
    const {
      dataIsFetching,
      dataLastUpdated,
      me,
      reports: reportsDataSource,
      patients,
      prescriptions,
      physicians,
      billingCodes,

      handleOnSortClick,
      handleOnFilterButtonClick,
      handleOnFilterChange,
      handleOnBulkAction,
      handleOnRowClick,
      handleOnRefreshClick,
      handleOnSelectionClick,
      refreshClicked,
      bulkActionComplete,
      bulkActionIsFetching,
      bulkActionSuccessMessage,

      reportIds,
      selectedPopover,
      selectedIndex,

      selectedStartDate,
      selectedEndDate,
      selectedPatientId,
      selectedPhysicianId,
      selectedPhysicians,
      selectedPrescriptionId,
      selectedBillingCode,
      selectedEsignedId,
      selectedExportedId,
      selectedReports,
      sortBy,
      sortDirection,
    } = this.props
    const {
      innerHeight,
      innerWidth,
    } = this.state

    const height = innerHeight - HEADER_HEIGHT - 11

    let reports = []
    if (me.data && me.data.teams[0].reports && reportsDataSource.data && !refreshClicked) {
      reports = reportIds.map(id => reportsDataSource.data.byId[id])
    }

    if (!checkRpmFeatureEnabled(me)) {
      return (
        <div
          data-page="reports"
          className={styles.reports}
        >
          <AccessDeniedContent title="Reports" />
        </div>
      )
    }

    return (
      <div data-page="reports" className={styles.reports}>
        <ContentHeader
          isLoading={dataIsFetching}
          showAddPatient={!(me.isFetching && !me.data)}
          showLastRefresh={!(me.isFetching && !me.data)}
          lastUpdated={dataLastUpdated}
          handleOnRefreshClick={handleOnRefreshClick}
          enrollPatient={true}
          text="Reports"
          me={me}
        />
        {me.isFetching && !me.data
          ? (
            <div>
              <EcgLoader />
            </div>
          )
          : (
            <React.Fragment>
              <div
                className={styles.tableContent}
                style={{
                  height,
                }}
              >
                <ReportTable
                  enableLoader={reportIds.length === 0 || refreshClicked}
                  showLoader={dataIsFetching}
                  data={reports}
                  showRowSelection={true}
                  selected={selectedReports}
                  onSelectionClick={handleOnSelectionClick}
                  height={height}
                  onRowClick={handleOnRowClick}
                  selectedIndex={selectedIndex}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  me={me}
                  filterEndDate={!moment(selectedStartDate).isSame(this.beginningDate, 'day') || !moment(selectedEndDate).isSame(this.today, 'day')}
                  filterPatient={selectedPatientId}
                  filterPhysician={
                    selectedPhysicians && selectedPhysicians.length > 0
                  }
                  filterPrescription={selectedPrescriptionId}
                  filterBillingCode={selectedBillingCode.length > 0}
                  filterEsign={selectedEsignedId !== getEsignOptions()[0].id}
                  filterExport={selectedExportedId !== getExportOptions()[0].id}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  handleOnFilterChange={handleOnFilterChange}
                  handleOnSortClick={handleOnSortClick}
                  handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
                  handleOnBulkAction={handleOnBulkAction}
                  handleOnBulkActionClearSelection={() => handleOnSelectionClick({})}
                  bulkActionComplete={bulkActionComplete}
                  bulkActionIsFetching={bulkActionIsFetching}
                  bulkActionSuccessMessage={bulkActionSuccessMessage}
                  selectedPopover={selectedPopover}
                  selectedStartDate={selectedStartDate}
                  selectedEndDate={selectedEndDate}
                  dateRange={[ this.beginningDate, this.today ]}
                  showPatientColumns={true}
                  patients={patients}
                  selectedPatientId={selectedPatientId}
                  physicians={physicians}
                  selectedPhysicianId={selectedPhysicianId}
                  selectedPhysicians={selectedPhysicians}
                  prescriptions={prescriptions}
                  selectedPrescriptionId={selectedPrescriptionId}
                  billingCodes={billingCodes}
                  selectedBillingCode={selectedBillingCode}
                  esignOptions={getEsignOptions().slice(1)}
                  selectedEsignedId={selectedEsignedId}
                  exportOptions={getExportOptions().slice(1)}
                  selectedExportedId={selectedExportedId}
                />
              </div>
            </React.Fragment>
          )}
        {/* {me.data
          && (
            <Help
              learnMoreIndex={3}
              previousLoginAt={me.data.profile.previousLoginAt}
              lastLoginAt={me.data.profile.lastLoginAt}
            />
          )
        } */}
      </div>
    )
  }
}

export default Reports



// WEBPACK FOOTER //
// ./src/legacy/pages/Reports/Reports.jsx